export default __webpack_public_path__ + "b4de1929d5eb805882b5a32d0bc4a2d9.png";